// src/components/layout/Layout.tsx
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import Footer from './Footer';
import MobileBottomNav from '@/components/ui/Mobile/MobileBottomNav';
import { useNavigation } from '@/context/NavigationContext';
import { useAuthContext } from '@/context/AuthContext';
import { useResponsive } from '@/hooks/useResponsive';
import { Outlet } from 'react-router-dom';
import styles from '@/styles/layout/Layout.module.css';

interface LayoutProps {
  children?: React.ReactNode; // Делаем children опциональным
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { } = useNavigation(); // Не используем currentPage
  const { isAuthenticated } = useAuthContext();
  const location = useLocation();
  useTranslation('translation');
  
  // Используем хук useResponsive
  const { isMobile, isTablet } = useResponsive();
  
  // Определяем, нужно ли показывать мобильную навигацию
  const shouldShowMobileNav = isAuthenticated && (isMobile || isTablet);

  // Функция для переключения состояния боковой панели
  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

  // Закрываем боковую панель при клике на оверлей
  const closeSidebar = () => {
    if (sidebarOpen) {
      setSidebarOpen(false);
    }
  };

  // Определяем, находимся ли мы на странице профиля или настроек пользователя
  // ИСПРАВЛЕНО: корректные пути с префиксом /personal/
  const isProfileOrSettings = location.pathname === '/personal/profile' || location.pathname === '/personal/user-settings';

  // Добавляем класс для отступа на страницах профиля или настроек пользователя
  const mainClassName = `${styles.main} ${
    shouldShowMobileNav 
      ? isProfileOrSettings 
        ? styles.mainWithMobileNav 
        : styles.mainWithMobileNav
      : styles.mainStandard
  }`;

  return (
    <div className={styles.layout}>
      {/* Передаем функцию переключения боковой панели */}
      <Header onToggleSidebar={toggleSidebar} />
      
      {/* Оверлей для закрытия боковой панели на мобильных */}
      {sidebarOpen && (
        <div 
          className={styles.overlay}
          onClick={closeSidebar}
          aria-hidden="true"
        />
      )}
      
      <main className={mainClassName}>
        <div className={styles.container}>
          {/* Используем Outlet для рендеринга дочерних маршрутов или children, если они предоставлены */}
          {children || <Outlet />}
        </div>
      </main>
      
      <Footer />
      
      {/* Мобильная навигация внизу экрана */}
      {shouldShowMobileNav && <MobileBottomNav />}
    </div>
  );
};

export default Layout;